import { Navigate } from 'react-router-dom';

const Templates = () => <Navigate to="/automations" replace />;

export default Templates;
